import { render, staticRenderFns } from "./scadenziarioVerificheRidotto.vue?vue&type=template&id=2e74c61a"
import script from "./scadenziarioVerificheRidotto.vue?vue&type=script&lang=js"
export * from "./scadenziarioVerificheRidotto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports